




























































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    mdbProgress, mdbRow, mdbCol, mdbCard, mdbView, mdbCardBody, mdbCardText, mdbMask, mdbListGroup, mdbIcon, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle,
    mdbDropdownItem, mdbBadge, mdbTooltip, mdbPopover, mdbBtn, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter
} from '@folky-tools/mdbvue';
import { authenticationService, authorizationManagerService, flagsmithService, businessesService, getBusinessPricingMaxLevelService, usersService, queryCampaignsService, QueryCampaignsOutputDto, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { FeatureType } from '@/models/applications/feature-type';
import { NewSpaceData } from '@/models/shared/new-space-data';

@Component({
    components: {
        mdbProgress,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbView,
        mdbCardBody,
        mdbCardText,
        mdbMask,
        mdbListGroup,
        mdbIcon,
        mdbDropdown,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbDropdownItem,
        mdbBadge,
        mdbTooltip,
        mdbPopover,
        mdbBtn,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        SuggestPwaInstall: () => import('@/components/shared/SuggestPwaInstall.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue'),
        NewSpace: () => import('@/components/shared/NewSpace.vue')
    }
})
export default class DashboardView extends Vue {
    @Prop() private readonly unviewedOrders!: number;
    private canListBusinesses: boolean = false;
    private canWriteOnlySingleBusiness: boolean = false;
    private canListAssociations: boolean = false;
    private canWriteOnlySingleAssociation: boolean = false;
    private isOwnerOfAnyCampaign: boolean = false;
    private isOwnerOfCampaignIds: number[] = [];
    private canListCampaigns: boolean = false;
    private canListReferences: boolean = false;
    private canListReferenceDiscounts: boolean = false;
    private canListServices: boolean = false;
    private canListBusinessOrders: boolean = false;
    private canListUserInvitations: boolean = false;
    private canListUserActionLogs: boolean = false;
    private canListBusinessBookingRequests: boolean = false;
    private canListUserBusinessProspects: boolean = false;
    private canListBusinessContacts: boolean = false;
    private businessProspectsFeatureToggleEnabled: boolean = false;
    private authorizedBusinessesIdToEdit: number[] = [];
    private authorizedAssociationsIdToEdit: number[] = [];
    private canAddAssociation: boolean = false;
    private canAddBusiness: boolean = false;
    private canEditReferences: boolean = true;
    private canAddReference: boolean = false;
    private canAddService: boolean = false;
    private canAddInvitation: boolean = false;
    private businessTradeName: string = '';
    private businessId: number | null = null;
    private permissionsLoadedTimer?: NodeJS.Timeout;
    private campaignsList: QueryCampaignsOutputDto[] = [];
    private campaignAppList: Array<{ id: number; displayName: string; appUrl: string }> = [];
    private maxBusinessPricingLevel: number | null = null;
    private hasNewMessages: boolean = false;
    private pageContentLoaded: boolean = false;
    private canActualUserAccessDinamizationApp: boolean = false;
    private canActualUserAccessLoyaltyApp: boolean = false;

    // #region NEW_SPACE
    private canCreateANewSmartAdministrationSpace: boolean = false;
    private showNewSmartAdministrationSpaceModal: boolean = false;
    private savingNewSmartAdministrationSpace: boolean = false;
    private spaceData: NewSpaceData = new NewSpaceData();
    // #endregion

    private async beforeMount(): Promise<any> {
        if (this.$route.query.businessProspectId) {
            const newBusinessResponse = await businessesService.newBusinessThroughProspect(+this.$route.query.businessProspectId);
            if (newBusinessResponse.result) {
                this.permissionsLoadedTimer = setInterval(() => this.tryToGoToBusinessDashboard(newBusinessResponse.id), 6000);
            }

            return;
        }

        this.canActualUserAccessDinamizationApp = await businessesService.canActualUserAccessDinamizationApp();
        this.canActualUserAccessLoyaltyApp = await businessesService.canActualUserAccessLoyaltyApp();
        this.canAddAssociation = authorizationManagerService.canCreateAssociations;
        this.canAddBusiness = authorizationManagerService.canCreateBusiness;
        this.canEditReferences = authorizationManagerService.isAdmin || (authorizationManagerService.authorizedReferenceIdsToEdit && authorizationManagerService.authorizedReferenceIdsToEdit.length > 0);
        this.canAddReference = authorizationManagerService.canCreateReferences;
        this.canAddService = authorizationManagerService.canCreateReferences;
        this.canAddInvitation = authorizationManagerService.canCreateUserInvitations;
        this.canWriteOnlySingleBusiness = authorizationManagerService.canWriteOnlySingleBusiness;
        this.canWriteOnlySingleAssociation = authorizationManagerService.canWriteOnlySingleAssociation;
        this.canListBusinesses = authorizationManagerService.canListBusiness;
        this.canListReferences = authorizationManagerService.canListReferences;
        this.canListReferenceDiscounts = authorizationManagerService.canCreateReferences;
        this.canListServices = authorizationManagerService.canListReferences;
        this.canListBusinessOrders = authorizationManagerService.canListBusinessOrders;
        this.isOwnerOfAnyCampaign = authorizationManagerService.isOwnerOfAnyCampaign;
        this.isOwnerOfCampaignIds = authorizationManagerService.isOwnerOfCampaignIds;
        this.canListCampaigns = authorizationManagerService.canListCampaigns;
        this.canListAssociations = authorizationManagerService.canListAssociations;
        this.canListUserInvitations = authorizationManagerService.canListUserInvitations;
        this.canListUserActionLogs = authorizationManagerService.isAdmin;
        this.canListUserBusinessProspects = authorizationManagerService.canListBusinessProspects;
        this.canListBusinessBookingRequests = authorizationManagerService.canListBusinessBookingRequests;
        this.canListBusinessContacts = authorizationManagerService.canListBusinessContacts;
        this.canCreateANewSmartAdministrationSpace = authorizationManagerService.isAdmin || authorizationManagerService.isCommercial;

        this.businessProspectsFeatureToggleEnabled = await flagsmithService.isFeatureEnabled(FeatureType.business_prospects_list);

        this.authorizedAssociationsIdToEdit = authorizationManagerService.authorizedAssociationsIdsToEdit;
        this.authorizedBusinessesIdToEdit = authorizationManagerService.authorizedBusinessIdsToEdit;

        if (this.canListCampaigns) {
            // Campaigns the user has access to (already excludes closed ones: isOutOfDate eq false).
            // Each one is shown as an access card that opens its own CampaignManagement app in a new
            // tab; only campaigns with a configured app URL for this environment are listed.
            this.campaignsList = await queryCampaignsService.execute();
            this.campaignAppList = this.campaignsList
                .map(campaign => ({ id: campaign.id, displayName: campaign.displayName, appUrl: this.campaignAppUrl(campaign.id) }))
                .filter(campaign => !!campaign.appUrl);
        }
        setTimeout(() => (this.pageContentLoaded = true), 200);

        if (this.canWriteOnlySingleBusiness) {
            const business = await businessesService.getBusiness(this.authorizedBusinessesIdToEdit[0]);
            this.businessTradeName = `${business.tradeName}`;
            this.businessId = business.id;
            this.maxBusinessPricingLevel = business.pricingLevel;

            this.reorderMasonryBlocks();
        } else {
            this.maxBusinessPricingLevel = await getBusinessPricingMaxLevelService.execute();
            this.reorderMasonryBlocks();
        }

        if (!authorizationManagerService.isAdmin) {
            const businessIds = authorizationManagerService.authorizedBusinessIdsToEdit;
            for (const businessId of businessIds) {
                if (await businessesService.hasBusinessNewMessages(businessId)) {
                    this.hasNewMessages = true;
                    break;
                }
            }
        }
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.dashboard.title');
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Users,
                scope: UserActionScopeType.Dashboard
            })
        );
    }

    private tryToGoToAssociationDashboard(associationId: number): void {
        if (authorizationManagerService.permissionsLoaded) {
            clearInterval(this.permissionsLoadedTimer!);
            this.$router.push(`/associations/dashboard/${associationId}?returnUrl=/dashboard`);
        }
    }

    private async tryToGoToBusinessDashboard(businessId: number): Promise<void> {
        if (authorizationManagerService.permissionsLoaded) {
            const business = await businessesService.getBusiness(businessId);
            clearInterval(this.permissionsLoadedTimer!);
            this.$router.push(`/businesses/dashboard/${businessId}?businessName=${encodeURIComponent(business.tradeName!)}&returnUrl=/dashboard`);
        }
    }

    private getProgressColor(value: number): string {
        if (value < 25) {
            return 'danger';
        } else if (value < 100) {
            return 'warning';
        } else {
            return 'success';
        }
    }
    private reorderMasonryBlocks(): void {
        setTimeout(() => (this as any).$redrawVueMasonry(), 100);
    }

    // Per-campaign CampaignManagement app URL for the current environment (VUE_APP_CAMPAIGN_ID_{id}_URL),
    // pointing at its dashboard.
    private campaignAppUrl(id: number): string {
        const url = process.env[`VUE_APP_CAMPAIGN_ID_${id}_URL`];
        // Carry the current language across (like the other app links) so the target app keeps eu/es.
        return url ? `${url}/dashboard?ui_locales=${this.$i18n.locale}` : '';
    }

    private get showAccessToDynamizationApp(): boolean {
        return process.env.VUE_APP_SHOW_ACCESS_TO_DYNAMIZATION_APP === 'true' && this.canActualUserAccessDinamizationApp;
    }

    private get linkToDynamizationApp(): string {
        return `${process.env.VUE_APP_DYNAMIZATION_URL}/dashboard?ui_locales=${this.$i18n.locale}`;
    }

    private get showAccessToMessagingApp() : boolean {
        return process.env.VUE_APP_SHOW_ACCESS_TO_MESSAGING_APP === 'true' && authorizationManagerService.isAdmin;
    }

    private get linkToMessagingApp(): string {
        return `${process.env.VUE_APP_MESSAGING_URL}/dashboard?ui_locales=${this.$i18n.locale}`;
    }

    private get showAccessToLoyaltyApp() {
        return process.env.VUE_APP_SHOW_ACCESS_TO_LOYALTY_APP === 'true' && this.canActualUserAccessLoyaltyApp;
    }

    private get linkToLoyaltyApp(): string {
        return `${process.env.VUE_APP_LOYALTY_URL}/dashboard?ui_locales=${this.$i18n.locale}`;
    }

    // #region NEW_SPACE

    private get showAccessToCreateNewSmartAdministrationSpaces(): boolean {
        return process.env.VUE_APP_SHOW_ACCESS_TO_CREATE_SMART_ADMIN_SPACES === 'true';
    }

    private openNewSmartAdministrationSpaceModal(): void {
        this.spaceData = new NewSpaceData();
        this.showNewSmartAdministrationSpaceModal = true;
    }

    private closeNewSmartAdministrationSpaceModal(): void {
        this.showNewSmartAdministrationSpaceModal = false;
    }

    private async createNewSmartAdministrationSpace(): Promise<void> {
        this.savingNewSmartAdministrationSpace = true;

        if ((this.$refs.newSpace as any).hasErrors()) {
            this.savingNewSmartAdministrationSpace = false;
            return;
        }

        try {
            const result: boolean = await businessesService.newSmartAdministrationSpace(this.spaceData);
            if (result) {
                notificationsService.showToastSuccessNotification('El nuevo espacio ADI ha sido creado correctamente.');
                this.closeNewSmartAdministrationSpaceModal();
            } else {
                notificationsService.showToastErrorNotification();
            }
        } catch (error) {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingNewSmartAdministrationSpace = false;
        }
    }

    // #endregion
}
